import { QuickLink, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import ButtonV2 from "elements/ButtonV2";

const ManufacturedHome = () => {
	const {
		next,
		manufacturedHomeModel,
		setManufacturedHomeModel,
		manufacturedHomeMake,
		setManufacturedHomeMake,
		manufacturedHomeId,
		setManufacturedHomeId,
	} = useExemptionsContext();
	const { details } = usePropertyContext();

	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		trackEvent({
			eventName: constants.EVENTS.Exemptions_Flow_Manufactured_Home_Page_Answer,
			data: {
				Make: manufacturedHomeMake ?? "",
				Model: manufacturedHomeModel ?? "",
				ID: manufacturedHomeId ?? "",
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			Make: manufacturedHomeMake ?? "",
			Model: manufacturedHomeModel ?? "",
			ID: manufacturedHomeId ?? "",
		};
		next({ trackingEventData });
	};

	const handleSkip = () => {
		trackEvent({
			eventName:
				constants.EVENTS.Exemptions_Flow_Manufactured_Home_Page_Skipped,
			data: {
				"Property ID": details?.id,
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"Property ID": details?.id,
			"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
				? "Yes"
				: "No",
		};
		next({ trackingEventData });
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>
						It looks like this property is a Manufactured Home. Please provide
						the following information.
					</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					This information is required by your county to correctly identify the
					property type and apply the homestead.
				</p>
				<TextField
					required
					label="Manufactured Home Make"
					placeholder="Manufactured Home Make"
					value={manufacturedHomeMake ?? ""}
					onChange={e => {
						setManufacturedHomeMake(e.target.value);
					}}
				/>
				<div className="exemptions-question-input-container">
					<TextField
						required
						label="Model"
						placeholder="Model"
						value={manufacturedHomeModel ?? ""}
						containerClassName="exemptions-question-input-container-split"
						onChange={e => {
							setManufacturedHomeModel(e.target.value);
						}}
					/>
					<TextField
						required
						label="ID Number"
						placeholder="ID Number"
						value={manufacturedHomeId ?? ""}
						containerClassName="exemptions-question-input-container-split"
						onChange={e => {
							setManufacturedHomeId(e.target.value);
						}}
					/>
				</div>
			</div>
			<ButtonV2
				size="large"
				disabled={
					!(manufacturedHomeMake && manufacturedHomeMake && manufacturedHomeId)
				}
				type="submit">
				Continue
			</ButtonV2>
			<div className="exemption-survey-skip">
				<QuickLink asButton onClick={() => handleSkip()}>
					Not a Manufactured Home
				</QuickLink>
			</div>
		</form>
	);
};

export default ManufacturedHome;
